// Note: these are "base" descriptions. For assessment subjects using shared due diligence assessments from another assessment subject, relevant steps' text will be extended.
export const ASSESSMENTS_IN_PROGRESS = 'Assessments in progress';
export const ASSESSMENTS_SUBMITTED = 'All assessments submitted';
export const FINAL_REVIEW_IN_PROGRESS = 'Final review in progress';
export const IRQ_FINALIZED = 'Inherent risk questionnaire finalized';
export const IRQ_IN_PROGRESS = 'Inherent risk questionnaire in progress';
export const IRQ_NOT_FINALIZED = 'Inherent risk questionnaire not yet finalized';
export const IRQ_SUBMITTED = 'Inherent risk questionnaire submitted';
export const QUESTIONNAIRES_IN_PROGRESS = 'Due diligence questionnaires in progress';
export const WORKFLOW_NOT_STARTED = 'Due diligence workflow not started';
export const WORKFLOW_STARTED = 'Due diligence workflow started';

export const TPRM_QUESTIONNAIRES_SUBMITTED = 'All questionnaires submitted by third party';
export const TPRM_SERVICE_FINALIZED = 'Third-party service finalized';
export const TPRM_SERVICE_NOT_SUBMITTED_TO_BE_FINALIZED = 'Third-party service not yet submitted to be finalized';
export const TPRM_SERVICE_PENDING_FINALIZATION = 'Third-party service pending finalization';
export const TPRM_SERVICE_SUBMITTED_TO_BE_FINALIZED = 'Third-party service submitted to be finalized';
export const TPRM_THIRD_PARTY_AND_SERVICE_CREATED = 'Third party and third-party service created';
export const TPRM_THIRD_PARTY_FINALIZED = 'Third party finalized';
export const TPRM_THIRD_PARTY_NOT_SUBMITTED_TO_BE_FINALIZED = 'Third party not yet submitted to be finalized';
export const TPRM_THIRD_PARTY_PENDING_FINALIZATION = 'Third party pending finalization';
export const TPRM_THIRD_PARTY_SUBMITTED_TO_BE_FINALIZED = 'Third party submitted to be finalized';

export const UCRM_BUSINESS_AND_USE_CASE_CREATED = 'Business and use case created';
export const UCRM_BUSINESS_FINALIZED = 'Business finalized';
export const UCRM_BUSINESS_NOT_SUBMITTED_TO_BE_FINALIZED = 'Business not yet submitted to be finalized';
export const UCRM_BUSINESS_PENDING_FINALIZATION = 'Business pending finalization';
export const UCRM_BUSINESS_SUBMITTED_TO_BE_FINALIZED = 'Business submitted to be finalized';
export const UCRM_QUESTIONNAIRES_SUBMITTED = 'All questionnaires submitted by respondents';
export const UCRM_USE_CASE_FINALIZED = 'Use case finalized';
export const UCRM_USE_CASE_NOT_SUBMITTED_TO_BE_FINALIZED = 'Use case not yet submitted to be finalized';
export const UCRM_USE_CASE_PENDING_FINALIZATION = 'Use case pending finalization';
export const UCRM_USE_CASE_SUBMITTED_TO_BE_FINALIZED = 'Use case submitted to be finalized';

// Note: submitting the Final Review is the final step of the due diligence workflow, but it's never actually shown as completed in the progress bar; the progress bar goes away for completed workflows.
// Also note: these are "base" lists of steps. For assessment subjects using shared due diligence assessments from another assessment subject, relevant steps' text will be modified.
export const TPRM_STEPS_FOR_TPRM_USER = [TPRM_THIRD_PARTY_AND_SERVICE_CREATED, TPRM_THIRD_PARTY_FINALIZED, TPRM_SERVICE_FINALIZED, WORKFLOW_STARTED, IRQ_SUBMITTED, TPRM_QUESTIONNAIRES_SUBMITTED, ASSESSMENTS_SUBMITTED];
export const TPRM_STEPS_FOR_NON_TPRM_USER = [TPRM_THIRD_PARTY_AND_SERVICE_CREATED, TPRM_THIRD_PARTY_SUBMITTED_TO_BE_FINALIZED, TPRM_SERVICE_SUBMITTED_TO_BE_FINALIZED, TPRM_THIRD_PARTY_FINALIZED, TPRM_SERVICE_FINALIZED, WORKFLOW_STARTED, IRQ_FINALIZED, TPRM_QUESTIONNAIRES_SUBMITTED, ASSESSMENTS_SUBMITTED];
// The UCRM lists mirror the TPRM lists above step for step (the UCRM listing page relies on the same step indexes).
export const UCRM_STEPS_FOR_UCRM_USER = [UCRM_BUSINESS_AND_USE_CASE_CREATED, UCRM_BUSINESS_FINALIZED, UCRM_USE_CASE_FINALIZED, WORKFLOW_STARTED, IRQ_SUBMITTED, UCRM_QUESTIONNAIRES_SUBMITTED, ASSESSMENTS_SUBMITTED];
export const UCRM_STEPS_FOR_NON_UCRM_USER = [UCRM_BUSINESS_AND_USE_CASE_CREATED, UCRM_BUSINESS_SUBMITTED_TO_BE_FINALIZED, UCRM_USE_CASE_SUBMITTED_TO_BE_FINALIZED, UCRM_BUSINESS_FINALIZED, UCRM_USE_CASE_FINALIZED, WORKFLOW_STARTED, IRQ_FINALIZED, UCRM_QUESTIONNAIRES_SUBMITTED, ASSESSMENTS_SUBMITTED];

// Intake.
export const ORGANIZATION_FORM_TEST_ID = 'organizationFormTestId';
export const ASSESSMENT_SUBJECT_FORM_TEST_ID = 'assessmentSubjectFormTestId';
export const IRQ_FORM_TEST_ID = 'irqFormTestId';
export const SUBMIT_FORM_TEST_ID = 'submitFormTestId';

export const TPRM_SUCCESS_MESSAGE_THIRD_PARTY = 'Third party saved.';
export const TPRM_SUCCESS_MESSAGE_SERVICE = 'Third-party service saved.';
export const SUCCESS_MESSAGE_IRQ = 'Inherent risk questionnaire saved.';

export const SEARCH_PARAM_COMPLETING_INTAKE = 'completingIntake';
export const SEARCH_PARAM_WORKFLOW_STEP = 'step';
export const SEARCH_PARAM_ORGANIZATION_ID = 'organizationId';
export const SEARCH_PARAM_ASSESSMENT_SUBJECT_ID = 'assessmentSubjectId';
export const SEARCH_PARAM_ORGANIZATION_ACTIONS = 'organizationActions';
export const SEARCH_PARAM_ASSESSMENT_SUBJECT_ACTIONS = 'assessmentSubjectActions';
export const SEARCH_PARAM_IRQ_ACTIONS = 'questionnaireActions';

export const ACTION_CREATED = 'created';
export const ACTION_SAVED = 'saved';
export const ACTION_SKIPPED = 'skipped';
export const ACTION_SUBMITTED = 'submitted';

export const UCRM_SUCCESS_MESSAGE_BUSINESS = 'Business saved.';
export const UCRM_SUCCESS_MESSAGE_USE_CASE = 'Use case saved.';
